import React from 'react';
import {Segment, List, Icon} from 'semantic-ui-react';

class ResultHowTo extends React.Component {

  renderHowToItem = (key) => {
    const howToObj = this.props.howTos[key];
    return (
      <List.Item key={key}>
        <div className='upVoteAreaLogo'>
            <Icon link name='triangle up' />
            <div className='score'>{howToObj.score}</div>
            <Icon link name='triangle down' />
        </div>
        <List.Content>
          <List.Header as='a' href={howToObj.link} >{howToObj.headline}</List.Header>
          <List.Description>{howToObj.excerpt}</List.Description>
        </List.Content>
      </List.Item>
    )
  };

  render() {
    return (
      <Segment attached loading={this.props.loading}>
        <List celled>
          { Object.keys(this.props.howTos).map(this.renderHowToItem) }
        </List>
      </Segment>
    );
  }

}

export default ResultHowTo;



// WEBPACK FOOTER //
// ./src/components/ResultHowTo.js